export const displayActivateAlert = () =>{
    let language = localStorage.getItem("lang");
    if(language === "en"){
        alert("In order for us to serve you, please activate your camera and microphone")
    }
    else if(language === "ar"){
        alert("حتى نتمكن من خدمتك الرجاء تفعيل الكاميرا والميكروفون");
    }
}

export const notSentOtpAlert = () =>{
    let language = localStorage.getItem("lang");
    if(language === "en"){
        alert("The verification code could not be sent, please try again later")
    }
    else if(language === "ar"){
        alert('تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق');
    }
}

export const optNotRight = () =>{
    let language = localStorage.getItem("lang");
    if(language === "en"){
        alert("The verification code is invalid")
    }
    else if(language === "ar"){
        alert('رمز التحقق غير صحيح');
    }
}

export const enterOtp = () =>{
    let language = localStorage.getItem("lang");
    if(language === "en"){
        alert("Please enter the verification code")
    }
    else if(language === "ar"){
        alert('برجاء ادخال رمز التحقق');
    }
}

export const reasonExit = () =>{
    let language = localStorage.getItem("lang");
    if(language === "en"){
        alert("Please state the reason for exiting the waiting lobby")
    }
    else if(language === "ar"){
        alert(' الرجاء ذكر سبب الخروج من الانتظار ');
    }
}